// SEARCH FILTER
const searchInput = document.getElementById('faq-search');
const allItems = document.querySelectorAll('.faq-item');
const allBlocks = document.querySelectorAll('.cat-block');
const matchCount = document.getElementById('match-count');
const noResults = document.getElementById('no-results');

searchInput.addEventListener('input', (e) => {
  const q = e.target.value.toLowerCase().trim();
  let matches = 0;

  if (q === '') {
    allItems.forEach(item => item.classList.remove('hidden'));
    allBlocks.forEach(block => block.style.display = '');
    matchCount.textContent = allItems.length;
    noResults.classList.remove('show');
    return;
  }

  allBlocks.forEach(block => {
    const items = block.querySelectorAll('.faq-item');
    let blockHas = 0;
    items.forEach(item => {
      const text = (item.querySelector('h4').textContent + ' ' + item.querySelector('.faq-a').textContent).toLowerCase();
      if (text.includes(q)) {
        item.classList.remove('hidden');
        blockHas++;
        matches++;
      } else {
        item.classList.add('hidden');
      }
    });
    block.style.display = blockHas > 0 ? '' : 'none';
  });

  matchCount.textContent = matches;
  if (matches === 0) {
    noResults.classList.add('show');
  } else {
    noResults.classList.remove('show');
  }
});

// SCROLLSPY — highlight active category pill based on scroll position
const pills = document.querySelectorAll('.cat-pill');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const id = entry.target.id;
      pills.forEach(p => p.classList.toggle('active', p.dataset.target === id));
    }
  });
}, { rootMargin: '-160px 0px -60% 0px', threshold: 0 });

allBlocks.forEach(block => observer.observe(block));

// Smooth scroll already handled by CSS scroll-behavior + scroll-margin-top on .cat-block
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
